import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

  export const createStatus = async (data) => {
      try {
        const response = await api.create('/history/', data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getHistory = async () => {
      try {                                                                            
        const response = await api.get(url.GET_HISTORYP);
        return response;
      } catch (error) {
        throw error;
      }
  };




 


  export const getHistoryUser = async (userId) => {
    try {
      const response = await axios.get(`/history/users/${userId}`);
      console.log("Réponse brute de l'API :", response); // Afficher la réponse complète de l'API
  
      // Retourner directement les données
      return response.data;  
    } catch (error) {
      console.error("Erreur lors de la récupération des véhicules :", error);
      throw new Error("Erreur lors de la récupération des véhicules");
    }
  };
  
  


  export const updateHistory = async ( id, data) => {
      try {
        const response = await axios.patch(url.UPDATE_HISTORY +'/'+id, data);
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getHistoryById = async (id) => {
    try {
      const response = await api.get(`/history/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
};

  export const deleteHistory = async (id) => {
    try {
        const response = await api.delete(url.DELETE_HISTORY +'/'+id);
        return response;
    } catch (error) {
        throw error;
    }
  };
